import { Clock, DollarSign, Users, Building2, TrendingUp } from 'lucide-react';
import { fmtMoney, fmtHours, fmtNumber } from './format';
import { card } from '../../theme';

function pctDelta(current, prior) {
  if (prior == null || prior === 0) return null;
  return ((current - prior) / prior) * 100;
}

function Delta({ delta }) {
  if (delta == null) return null;
  const up   = delta > 0;
  const zero = Math.abs(delta) < 0.05;
  if (zero) return <div style={s.deltaFlat}>— 0%</div>;
  const color = up ? '#DC2626' : '#16A34A';
  const arrow = up ? '▲' : '▼';
  return <div style={{ ...s.delta, color }}>{arrow} {Math.abs(delta).toFixed(1)}%</div>;
}

export default function OvertimeKpis({ kpis, priorKpis }) {
  const k = kpis || {};
  const p = priorKpis || null;

  const cards = [
    { label: 'Overtime Cost',      value: fmtMoney(k.ot_amount),             icon: <DollarSign size={16} />, accent: '#DC2626', delta: pctDelta(k.ot_amount,             p?.ot_amount) },
    { label: 'Overtime Hours',     value: fmtHours(k.ot_hours),              icon: <Clock size={16} />,      accent: '#A16207', delta: pctDelta(k.ot_hours,              p?.ot_hours) },
    { label: 'Employees w/ OT',    value: fmtNumber(k.employee_count),       icon: <Users size={16} />,      accent: '#1B2A4A', delta: pctDelta(k.employee_count,        p?.employee_count) },
    { label: 'Cost Centers',       value: fmtNumber(k.cost_center_count),    icon: <Building2 size={16} />,  accent: '#1B2A4A', delta: null },
    { label: 'Avg Hrs / Employee', value: fmtHours(k.avg_hours_per_employee),icon: <TrendingUp size={16} />, accent: '#16A34A', delta: pctDelta(k.avg_hours_per_employee, p?.avg_hours_per_employee) },
  ];

  return (
    <div style={s.grid}>
      {cards.map((c) => (
        <div key={c.label} style={s.card}>
          <div style={{ ...s.iconWrap, color: c.accent, background: `${c.accent}14` }}>{c.icon}</div>
          <div style={s.body}>
            <div style={s.value}>{c.value}</div>
            <div style={s.label}>{c.label}</div>
            <Delta delta={c.delta} />
          </div>
        </div>
      ))}
    </div>
  );
}

const s = {
  grid:      { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '14px', marginBottom: '24px' },
  card:      { ...card.base, padding: '16px 18px', display: 'flex', alignItems: 'center', gap: '14px' },
  iconWrap:  { width: '38px', height: '38px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  body:      { minWidth: 0 },
  value:     { fontSize: '22px', fontWeight: 700, color: '#111827', lineHeight: 1.1 },
  label:     { fontSize: '11px', color: '#6B7280', marginTop: '3px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 },
  delta:     { fontSize: '10px', fontWeight: 600, marginTop: '4px' },
  deltaFlat: { fontSize: '10px', fontWeight: 600, marginTop: '4px', color: '#9CA3AF' },
};
